import React, { useState, useEffect, FC } from 'react';
import KickImage from 'Reuseables/KickImage';
import ProductSliderType2 from "./Helpers/ProductSliderType2"
import { getCollectionList } from "../../../actions/productAction"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

type CollectionSection = {
  category: string;
  history: History;
  getCollectionList: (params: Object) => any;
  dataCategory: string;
}

const CollectionSection: FC<CollectionSection> = ({ category, history, getCollectionList, dataCategory }) => {

  const [peoples, setPeoples] = useState([])

  useEffect(() => {

    let {selected} = dataCategory

    let params = {
      params: {
        category: selected,
        peoples: true
      }
    }

    getCollectionList(params)
    .then(({ value }: Object) => {
      let temp = []

      let tempArray = value.data.data

      for(let i = 0 ; i < tempArray.length ; i++) {
        temp.push(tempArray[i].name)
      }

      setPeoples(temp)
    })
    .catch((e: string) => console.log(e))
  }, [])

  return (
    <div className="collection-container__V3">
      {
        window.screen.availWidth > 480 &&
        <div className="collection-title__V3">
          <h6>Collection</h6>
        </div>
      }
      <div className="collectionSlider__V3">
        {
          peoples && peoples.length > 0 &&
          <ProductSliderType2
            options={peoples}
            history={history}
            category={category}
          />
        }
      </div>
    </div>
  )
}

interface CollectionSectionState {
  dataCategory: Object
}

const mapStateToProps = (state: CollectionSectionState) => ({
  dataCategory: state.dataCategory,
})

const mapDispatchToProps = (dispatch: any) => ({
  getCollectionList: (params: Object) => dispatch(getCollectionList(params))
})


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CollectionSection))
